import Layout from "../components/utils/layout";
import Filters from "./filters";
import React from "react";
import Formatters from "../components/utils/formatters";
import NamedQueryModule from "../components/data_modules/named_query_module";


const MonthlyExpiryList = () => {
    const screenId="MonthlyExpiryList"
    const formatters = Formatters()
    const charts = {
        monthly_expiry_active_and_paying : {
            specialFormatters:{
                card_id:formatters.card_id_link,
                user_id:formatters.account_id_link,
                owner_id:formatters.account_id_link,
                expiry_month:formatters.isoMonth,
                next_billing_date:formatters.isoDate,
                pricing_email_date:formatters.isoDate,
                pricing_email:formatters.int_to_bool,
                expiry_email:formatters.int_to_bool,
                cancellation_email:formatters.int_to_bool,
                tier_id:formatters.int
            }
        },
        monthly_expiry_blacklist : {
            specialFormatters: {
                card_id:formatters.card_id_link,
                user_id:formatters.account_id_link,
                owner_id:formatters.account_id_link,
                expiry_month:formatters.isoMonth,
                next_billing_date:formatters.isoDate,
                pricing_email_date:formatters.isoDate,
                pricing_email:formatters.int_to_bool,
                expiry_email:formatters.int_to_bool,
                cancellation_email:formatters.int_to_bool,
                tier_id:formatters.int
            }
        }
    }

    return <Layout prefsPrefix={screenId} items={charts}/>
}

export default MonthlyExpiryList
